const viteEnv = import.meta.env as Record<string, string | boolean | undefined>;

const baseUrl = String(viteEnv.VITE_BASE_URL || '#{BaseUrl}');

export const environment = {
  production: Boolean(viteEnv.PROD),
  baseUrl,
};

export default environment;
